// login page events
export const P2P_LOGIN_BTN_CLICK: string = "p2p_1_login_btn";
export const P2P_REFER_EARN_BTN:string = "p2p_1_refer_earn_btn";

// otp page events
export const P2P_OTP_VIEW:string = "p2p_2_otp_view";
export const P2P_OTP_BTN: string = "p2p_2_otp_btn";
export const P2P_RESEND_OTP_BTN: string = "p2p_2_resend_otp_btn";

// basic details page events
export const P2P_BASIC_DETAILS_VIEW : string= "p2p_3_basic_details_view";
export const P2P_BASIC_DETAILS_BTN : string = "p2p_3_basic_details_btn";

// connect bank details page events
export const P2P_BANKING_DETAILS_VIEW : string = "p2p_4_banking_details_view";
export const P2P_BANKING_DETAILS_BTN : string = "p2p_4_banking_details_btn";

// lender agreement page events
export const P2P_LENDER_AGREEMENT_VIEW : string= "p2p_6_lender_agreement_view";
export const P2P_LENDER_AGREEMENT_BTN : string= "p2p_6_lender_agreement_btn";

// new user dashboard page events
export const P2P_NEW_INVESTOR_DASHBOARD_VIEW : string= "p2p_7_new_investor_dashboard_view"
export const P2P_ADD_MONEY_ND_BTN :string = "p2p_7_add_money_nd_view";
export const P2P_REFER_ND_BTN : string = "p2p_7_refer_nd_btn";
export const P2P_HELP_ND_BTN : string = "p2p_7_help_nd_btn";

// add money page events
export const P2P_AMOUNT_SELECTION_VIEW : string ="p2p_8_amount_selection_view";
export const P2P_AMOUNT_SELECTION_BACK_BTN : string = "p2p_8_amount_selection_back_btn";
export const P2P_INVEST_NOW_BTN : string = "p2p_8_invest_now_btn";

// invest funds page events
export const P2P_PAYMENT_MODE_VIEW: string = "p2p_9_payment_mode_view"; //same for bankDetails page
export const P2P_NEFT_PAYMENT_MODE_BTN : string = "p2p_9_neft_payment_mode_btn";
export const P2P_PG_PAYMENT_MODE_BTN : string = "p2p_9_pg_payment_mode_btn";

// payment response page events
export const P2P_PG_SUCCESSFUL_PAYMENT_VIEW : string = "p2p_10_pg_successful_payment_view";
export const P2P_PG_SUCCESSFUL_PAYMENT_BTN: string = "p2p_10_pg_successful_payment_btn"

// existing user page events
export const P2P_FD_VIEW: string = "p2p_11_final_dashboard_view";
export const P2P_FD_TRANSACTION_BTN: string = "p2p_11_fd_view_transaction_btn"; //where
export const P2P_FD_HELP_BTN : string = "p2p_11_fd_help_btn";
export const P2P_WITHDRAW_BTN :string = "p2p_11_fd_withdraw_btn";
export const P2P_FD_ADD_MONEY_BTN: string = "p2p_11_fd_add_money_btn";

// refer earn page events
export const P2P_REFER_EARN_VIEW: string = "p2p_12_refer_earn_view";
export const P2P_COPY_LINK_BTN: string = "p2p_12_copy_link_btn";
export const P2P_REFER_NOW_BTN : string = "p2p_12_refer_now_btn";
export const P2P_BACK_BTN : string = "p2p_12_back_btn";

// withdraw funds page events
export const P2P_WITHDRAW_FUNDS_VIEW : string = "p2p_12_withdraw_funds_view";
export const P2P_HELP_BTN :string = "p2p_12_help_btn";

// help page events
export const P2P_HELP_VIEW : string = "p2p_13_help_view";
export const P2P_RAISE_TCK_BTN :string = "p2p_13_raise_tck_btn";
export const P2P_HELP_SUBMIT_FORM_VIEW : string = "p2p_14_help_submit_form_view";
export const P2P_HELP_SUBMIT_FORM_BTN : string = "p2p_14_help_submit_form_btn";
export const P2P_HELP_SUCCESSFUL_VIEW : string = "p2p_14_help_successful_view";